// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Questionnare-setup-container {
    padding-bottom: 100px;
}

@media screen and (max-width:1600px) {
    .Questionnare-setup-container{
        /* zoom: 85%; */
    }
}

.Questionare-setup-textarea {
    width: 100%;
    font-size: 1rem;
    
}


@media screen and (min-width:900px) {
    .Questionare-setup-textarea {
        padding: 16.5px;
        padding: 20px 20px 20px 30px !important;
    }
}
.Questionnare-setup-label{
    overflow: visible !important;
    white-space: break-spaces !important;
    padding: 5px !important;
}
.questionnare-custom-error {
    color: #d32f2f;
    font-family: Arial, sans-serif;
    font-weight: 400;
    font-size: 0.75rem;
    line-height: 1.66;
    text-align: left;
    margin-top: 3px;
    margin-right: 14px;
    margin-bottom: 0;
    margin-left: 14px;
}

[data-tooltip-calculation] {
    position: relative;
  }
  
  [data-tooltip-calculation]:before {
    content: attr(data-tooltip-calculation);
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    padding: 5px 10px;
    background: rgba(0, 0, 0, 0.8);
    color: white;
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
    z-index: 1000;
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.2s;
  }
  
  [data-tooltip-calculation]:hover:before {
    visibility: visible;
    opacity: 1;
  }

  .full-width-table-question-dropdown {
    width: 100%;
    border-spacing: 0 20px;
    height: 50px;
}

.full-width-table-question-dropdown td {
    width: auto;
    padding: 10px 8px;
    /* Add padding for better readability */
}

.disable-select-labels .MuiInputLabel-root {
  -webkit-user-select: none;
          user-select: none;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/QuestionnareSetup/Questionnare.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;AACzB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;;AAEnB;;;AAGA;IACI;QACI,eAAe;QACf,uCAAuC;IAC3C;AACJ;AACA;IACI,4BAA4B;IAC5B,oCAAoC;IACpC,uBAAuB;AAC3B;AACA;IACI,cAAc;IACd,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;EACpB;;EAEA;IACE,uCAAuC;IACvC,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,iBAAiB;IACjB,8BAA8B;IAC9B,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,wBAAwB;EAC1B;;EAEA;IACE,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,uCAAuC;AAC3C;;AAEA;EACE,yBAAiB;UAAjB,iBAAiB;AACnB","sourcesContent":[".Questionnare-setup-container {\n    padding-bottom: 100px;\n}\n\n@media screen and (max-width:1600px) {\n    .Questionnare-setup-container{\n        /* zoom: 85%; */\n    }\n}\n\n.Questionare-setup-textarea {\n    width: 100%;\n    font-size: 1rem;\n    \n}\n\n\n@media screen and (min-width:900px) {\n    .Questionare-setup-textarea {\n        padding: 16.5px;\n        padding: 20px 20px 20px 30px !important;\n    }\n}\n.Questionnare-setup-label{\n    overflow: visible !important;\n    white-space: break-spaces !important;\n    padding: 5px !important;\n}\n.questionnare-custom-error {\n    color: #d32f2f;\n    font-family: Arial, sans-serif;\n    font-weight: 400;\n    font-size: 0.75rem;\n    line-height: 1.66;\n    text-align: left;\n    margin-top: 3px;\n    margin-right: 14px;\n    margin-bottom: 0;\n    margin-left: 14px;\n}\n\n[data-tooltip-calculation] {\n    position: relative;\n  }\n  \n  [data-tooltip-calculation]:before {\n    content: attr(data-tooltip-calculation);\n    position: absolute;\n    bottom: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n    padding: 5px 10px;\n    background: rgba(0, 0, 0, 0.8);\n    color: white;\n    border-radius: 4px;\n    font-size: 12px;\n    white-space: nowrap;\n    z-index: 1000;\n    visibility: hidden;\n    opacity: 0;\n    transition: opacity 0.2s;\n  }\n  \n  [data-tooltip-calculation]:hover:before {\n    visibility: visible;\n    opacity: 1;\n  }\n\n  .full-width-table-question-dropdown {\n    width: 100%;\n    border-spacing: 0 20px;\n    height: 50px;\n}\n\n.full-width-table-question-dropdown td {\n    width: auto;\n    padding: 10px 8px;\n    /* Add padding for better readability */\n}\n\n.disable-select-labels .MuiInputLabel-root {\n  user-select: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
